const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/courses/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const coursesSearchSchema = z.object({
  page: z.coerce.number<number>().int().positive().optional().catch(1),
  status: z.string().optional().catch(undefined),
  query: z.string().optional().catch(undefined),
  course_type: z.string().optional().catch(undefined),
  order: z.record(z.string(), z.enum(["asc", "desc"])).optional().catch(undefined)
});
export const Route = createFileRoute("/_protected/_settingsLayout/settings/courses/")({
  validateSearch: coursesSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});